import React from 'react';
import PropTypes from 'prop-types';
import { CONFORT_BAR_OFFSET, BAR_MAX_HEIGHT } from './constants';
import { BarLabel } from './styles';

const RADIUS = 2;

export const Bar = (props) => {
  const {
    x, y, width, height, color, label, labelSkipWidth,
  } = props;
  const fixedHeight = height > BAR_MAX_HEIGHT ? BAR_MAX_HEIGHT : height;

  /**
   * P.O. wants one side of the bar to be rounder :/
   * this fix is from chatgpt because i dont know how to make the bar to be rounded one side only
   * but to make both sides rounded we could be using only rx and ry in the rect tag
   * IMPORTANT the bar with 0 results will start falling off while increasing the RADIUS!
  */
  return (
    <>
      <g>
        <path
          d={`
        M ${x + CONFORT_BAR_OFFSET} ${y + height / 2 - fixedHeight / 2}
        H ${x + width - RADIUS}
        Q ${x + width} ${y + height / 2 - fixedHeight / 2} ${x + width} ${y + height / 2 - fixedHeight / 2 + RADIUS}
        V ${y + height / 2 + fixedHeight / 2 - RADIUS}
        Q ${x + width} ${y + height / 2 + fixedHeight / 2} ${x + width - RADIUS} ${y + height / 2 + fixedHeight / 2}
        H ${x + CONFORT_BAR_OFFSET}
        Z
      `}
          fill={color}
        />
        {
          width > labelSkipWidth && (
            <BarLabel
              x={x + width / 2}
              y={y + height / 2}
              textAnchor="middle"
              dominantBaseline="central"
            >
              {label}
            </BarLabel>
          )
        }
      </g>
    </>
  );
};

Bar.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelSkipWidth: PropTypes.number.isRequired,
};
